import axios from "axios";

import { BASE_URL } from "../../../constant";
import {
    handleFormatResponse,
    handleFormatResponseForError,
} from "../../../utility";
import { IResponseFormat } from "libs/data-access/types";

export const useAffiliateData = () => {
    const getAffiliateData = async (url: string) => {
        try {
            let response = await axios.get(`${BASE_URL}affiliate${url && url}`);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const postAffiliateData = async (url: string, payload: any) => {
        try {
            let response;
            if (payload == null) {
                response = await axios.post(`${BASE_URL}affiliate${url && url}`)
            } else {
                response = await axios.post(`${BASE_URL}${url}`, payload)
            };
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const putAffiliateData = async (url: string, payload: any) => {
        try {
            let response = await axios.put(`${BASE_URL}affiliate${url && url}`, payload);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const patchAffiliateData = async (url: string, payload?: any) => {
        try {
            let response = await axios.patch(`${BASE_URL}affiliate${url && url}`, payload && payload);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const deleteAffiliateData = async (url: string) => {
        try {
            let response = await axios.delete(`${BASE_URL}affiliate${url && url}`);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };


    return {
        getAffiliateData,
        postAffiliateData,
        putAffiliateData,
        patchAffiliateData,
        deleteAffiliateData
    };

};